import React from 'react'
import { connect } from "react-redux";
import { NavLink } from 'react-router-dom'
import { Icon } from "semantic-ui-react";
import { Card } from 'semantic-ui-react'
import isUuid from "../../is_uuid";
import { getCurrentOffice } from "../../selectors/offices";

class DossiersListItem extends React.Component {

  render () {
    const { dossier, view } = this.props

    return (
      <Card as={NavLink} key={dossier.id} to={Routes.dossier_path({id: dossier.id, _options: true})} centered>
        <Card.Content>
          <Card.Header>
            {dossier.patient && dossier.patient.firstName} {dossier.patient && dossier.patient.lastName}
          </Card.Header>
          <Card.Meta>
            {I18n.t('components.dossier_list_item.since', { date: I18n.l("date.formats.default",dossier.createdAt) })}
          </Card.Meta>
          <Card.Meta>
            {dossier.dossierNumber && I18n.t('components.dossier_list_item.dossier_number') + " " + dossier.dossierNumber }
          </Card.Meta>
          <Card.Meta>
            {dossier.patient && dossier.patient.email}
          </Card.Meta>
          <Card.Meta>
            {dossier.patient && dossier.patient.phone}
          </Card.Meta>
          <Card.Meta>
            {dossier.patient && dossier.patient.securityNumber && I18n.t('components.dossier_list_item.security_number') + " " + dossier.patient.securityNumber}
          </Card.Meta>
        </Card.Content>
        {view === 'admin' &&
         <Card.Content extra>
           {dossier.responsibles?.map(resp => <div key={`responsible-${resp.id}`}><Icon style={{color: resp.color }} name="user"/> {resp.name}</div>)}
         </Card.Content>
        }
    </Card>)
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    view: state.view
  }
}

export default connect(mapStateToProps)(DossiersListItem);


